import { RootState } from '../store';

export const selectEchecksReducer = ({ echecksReducer }: RootState) => echecksReducer;
